import { render } from "./TaskDialog.vue?vue&type=template&id=e6dbfeda&scoped=true"
import script from "./TaskDialog.vue?vue&type=script&lang=js"
export * from "./TaskDialog.vue?vue&type=script&lang=js"

import "./TaskDialog.vue?vue&type=style&index=0&id=e6dbfeda&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-e6dbfeda"

export default script